import script from "./LoginBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginBox.vue?vue&type=script&lang=ts&setup=true"

import "./LoginBox.vue?vue&type=style&index=0&id=6901b2c9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6901b2c9"]])

export default __exports__